import { DedicatedBookingPage } from "@/components/booking/DedicatedBookingPage";

export default function BookingLdPartnership() {
  return <DedicatedBookingPage service="ld_partnership" />;
}
